import React from "react";
import "./Banner.css";
const Banner = () => {
  const bannar = "https://i.ibb.co/4ZztXNn/bannar2.png";
  return (
    <div className="">
      <div className="banner-wrapper row ">
        <div className="d-md-flex my-5 order-md-first justify-content-center col-md-7 col-12 ">
          <div className="writing-part">
            <p className="small-title">
              Hi, I am a <span className="softeng">Software Engineer</span>{" "}
            </p>
            <p className="small-title">
              <span className="threeyrs"> 3 years</span> of work experience in
              Tech Indusrty{" "}
            </p>
            <h1 className="main-title">
              <span className="arifur">
                My <span className="research">Research</span> Interests Below{" "}
              </span>
            </h1>
            <p className="interests-list">
              Data Science, Artificial Intelligence, Machine Learning, <br />{" "}
              Software Engineering, Web Development
            </p>
            <a
              href="https://drive.google.com/file/d/19IceybhEVyhn6SanzYvOWbMaojXFn8PK/view?usp=sharing"
              target="blank"
              download
            >
              <button class="button-80 mx-3 my-3"> My Resume</button>
            </a>
          </div>
        </div>
        <div className="img-part col-md-5 col-12 order-first ">
          <img
            className="img-fluid rounded-circle my-img"
            src={bannar}
            alt=""
          />
        </div>
      </div>
    </div>
  );
};

export default Banner;
